export let data = {
  title: "Lab",
  backBtn: "",
  actionBtn: [

  ],
  breadcrumb: []
};
export let tabs = [
  { title: "SEMUA", filter: ""},
  { title: "BELUM DIBAYAR",filter: "Belum Dibayar", active: true },
  { title: "BELUM LUNAS",filter: "Belum Lunas" },
  { title: "LUNAS", filter: "Lunas" }
];
export let sorts = [
  {
    value: "desc",
    label: "Terbaru"
  },
  {
    value: "asc",
    label: "Terlama"
  }
];
export let filters = {
  colnum: "",
  columns: [
    {
      label: "dari tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_from",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateStart"
    },
    {
      label: "sampai tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_to",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateEnd"
    },
  ]
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "desc",
      name:"orderBy",
      mandatory: true,
      options: sorts
    }
  ]
};
